import { PaziaModal } from "components/molecules";
import { PaziaLoader } from "components/atoms";
import { ModalHeader } from "components/templates/Modals/ModalHeader";
import { ModalPadding } from "components/templates/Modals/ModalPadding";
import { useCourseScheduleHistory } from "api/hooks/useCourseScheduleHistory";
import { formatDate } from "utils";
import { htmlParser } from "utils/htmlParser";

interface ScheduleHistoryModalProps {
  isOpen: boolean;
  onCloseRequest: () => void;
  courseId: number;
}

export const ScheduleHistoryModal = ({ isOpen, onCloseRequest, courseId }: ScheduleHistoryModalProps) => {
  const { data, loading } = useCourseScheduleHistory(isOpen ? courseId : undefined);

  return (
    <PaziaModal id="schedule-history-modal" isOpen={isOpen} onCloseRequest={onCloseRequest} size="lg">
      <ModalPadding>
        <ModalHeader>Historia harmonogramu</ModalHeader>

        {loading ? (
          <PaziaLoader />
        ) : (
          <div className="flex flex-col gap-4 overflow-auto" style={{ maxHeight: "60vh" }}>
            {data.length === 0 && <span className="text-sm italic">Brak historii zmian.</span>}
            {data.map((activity) => (
              <div
                key={activity.id}
                className="relative rounded-xl border bg-slate-100 px-4 pb-1 pt-7 text-sm dark:bg-slate-700"
              >
                <div className="absolute left-2 top-2 text-xs text-slate-400">
                  {formatDate(activity.createdDate, true, true)}
                </div>
                {htmlParser.toHTML(activity.description)}
                <div className="text-end text-sm font-medium text-slate-500">{activity.author.email}</div>
              </div>
            ))}
          </div>
        )}
      </ModalPadding>
    </PaziaModal>
  );
};
